import WebServiceRequest from '../Api/WebServiceRequest'

class BankCardCreateOrUpdateRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('BankCard/CreateOrUpdate')
    }
    setParams(data){
        super.setRequestParamDataObj(data)
    }
}

class BankCardDeleteRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('BankCard/Delete')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}

class BankCardSetDefaultCardRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('BankCard/SetDefaultCard')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}

class BankCardGetRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('BankCard/Get')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}

class BankCardGetListRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setTag('BankCard/GetList')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}

export {
    BankCardCreateOrUpdateRequest,
    BankCardDeleteRequest,
    BankCardGetRequest,
    BankCardGetListRequest,
    BankCardSetDefaultCardRequest
}